import React, { Component } from 'react';
import firebase from '../firebase.js';
import DocumentForm from '../components/documentForm.js';
import { Redirect } from 'react-router-dom'


/*
Mitkä muuttujat pitää olla?
Miten tehdä järkevästi vaikka 20 muuttujan formi?
Tätä samaa formia käytetään myös document new ja document edit?
->eli siitä erillinen komponentti?
Miten lisätään default valueiksi vanhat arvot?
*/

export default class DocumentEdit extends Component {

  constructor (props) {
    super();
    this.state = {
      redirect: false
    }
    this.saveItem = this.saveItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
  }

  removeItem(e) {
      e.preventDefault();
      if (window.confirm("Oletko varma, että haluat poistaa dokumentin " + this.props.item.data.documentName + "? \n\n Tätä toimintoa ei voi kumota.")) {
        const itemRef = firebase.database().ref(`documents/${this.props.user.uid}/${this.props.match.params.id}`);
        itemRef.remove();
        this.props.onDelete();
      }
    }

  saveItem(doc, e){
    e.preventDefault(); // <- prevent form submit from reloading the page

    const itemRef = firebase.database().ref(`documents/${this.props.user.uid}`);
    itemRef.child(this.props.item.id).update({data: doc});
    this.setState({redirect: true});
  }


  render () {
    if(this.state.redirect) {
      return(
        <Redirect to={`/document/${this.props.item.id}`} />
      )
    }
    return (
      <div>
        <h1>Muokkaa tietoja</h1>
        <DocumentForm autoFill={this.props.item.data} onSave={this.saveItem} onDelete={this.removeItem} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/documentEdit.js